import { getLocale } from "../runtime";

const sv_icondelivery = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Leverans`
};

const icondelivery = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_icondelivery(inputs)
	return "iconDelivery";
};

export { icondelivery as "iconDelivery" };